<template>
  <li :class="'p-risk__item --' + category">
    <div v-if="here" class="p-risk__btn --on">
      <p class="p-risk__btn__upper">
        <img class="p-risk__btn__img" :src="getImage(pict)" />
      </p>
      <p class="p-risk__btn__text" v-html="label"></p>
    </div>
    <img v-else-if="image" class="p-risk__alt-btn" :src="getImage(image)" />
    <a v-else-if="sub" class="p-risk__btn p-risk__btn--sub" :href="'/risk/' + next">
      <p class="p-risk__btn__title" v-html="label"></p>
    </a>
    <a v-else class="p-risk__btn" @click="clickBtn(next)">
      <p class="p-risk__btn__upper">
        <img class="p-risk__btn__img" :src="getImage(pict)" />
      </p>
      <p class="p-risk__btn__text" v-html="label"></p>
    </a>
  </li>
</template>

<script>
export default {
  name: "RiskNavBtn",
  components: {},
  props: {
    category: String,
    here: Boolean,
    image: String,
    sub: Boolean,
    pict: String,
    label: String,
    next: String,
  },
  // data() {},
  computed: {
    getImage() {
      return (pict) => {
        if (pict) {
          return require("@/assets/img/risk/" + pict);
        }
      };
    },
  },
  methods: {
    clickBtn(next) {
      this.$emit("update-condition", next);
    },
  },
};
</script>

<style scoped lang="scss">
.p-risk {
  &__item {
    @include sp {
      width: calc((100% - 18px) / 2);
      aspect-ratio: 1;
    }
  }
  &__btn {
    display: flex;
    flex-flow: column;
    justify-content: flex-end;
    align-items: center;
    background-color: #fff;
    border: 4px solid #000;
    border-radius: 7px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    @include pc {
      width: 175px;
      height: 175px;
      padding: 15px;
    }
    @include sp {
      width: 100%;
      height: 100%;
      padding: 14px;
    }
    &.--on {
      box-shadow: none;
    }
    .--life & {
      border-color: $color-risk-life;
      color: $color-risk-life;
    }
    .--health & {
      border-color: $color-risk-health;
      color: $color-risk-health;
    }
    .--estate & {
      border-color: $color-risk-estate;
      color: $color-risk-estate;
    }
    .--car & {
      border-color: $color-risk-car;
      color: $color-risk-car;
    }
    &--sub {
      justify-content: center;
      border: 0;
      .--life & {
        background-color: $color-risk-life-light;
        color: $color-risk-life-dark;
      }
      .--health & {
        background-color: $color-risk-health-light;
        color: $color-risk-health-dark;
      }
      .--estate & {
        background-color: $color-risk-estate-light;
        color: $color-risk-estate-dark;
      }
      .--car & {
        background-color: $color-risk-car-light;
        color: $color-risk-car-dark;
      }
    }
    &__upper {
      display: flex;
      align-items: center;
      @include pc {
        height: 85px;
      }
    }
    &__text {
      font-weight: 800;
      @include pc {
        @include font-size(17px);
      }
      @include sp {
        @include font-size(16px);
      }
      &:deep span {
        @include pc {
          @include font-size(30px);
        }
        @include sp {
          @include font-size(28px);
        }
      }
    }
    &__title {
      font-weight: 800;
      text-align: center;
      line-height: 1.4;
      @include font-size(17px);
    }
  }
  &__alt-btn {
    @include pc {
      max-width: 175px;
      max-height: 175px;
    }
    @include sp {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>